<template>
  <div class="proclamation">
    <div class="list">
      <div class="header">
        <h3>最新公告</h3>
        <router-link class="more" to="/layout/news/245">更多>></router-link>
      </div>
      <ul>
        <li v-for="item in announcement" :key="item.basicId">
          <router-link :to="'/layout/article/245/'+item.basicId" class="title">{{item.basicTitle}}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      announcement: []
    };
  },
  computed: {
    ...mapGetters(["getCategoryAppid"])
  },
  watch: {
    getCategoryAppid(id) {
      this.getAnnouncement(id);
    }
  },
  created() {
    this.getAnnouncement(this.$store.state.categoryAppid);
  },
  methods: {
    ...mapActions(["findPage"]),
    getAnnouncement(id) {
      this.findPage({
        basicCategoryid: 245,
        basicType: id,
        paeg: 1,
        size: 100
      }).then(res => {
        this.announcement = res.data.dataList;
        // console.log(res)
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  border-bottom: 3px solid #018fd7;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  padding: 5px;
  align-items: flex-end;
  .more {
    font-size: 12px;
  }
}
.proclamation {
  // display: flex;
  width: 100%;
  img {
    width: 20%;
  }
  .list {
    h3 {
      width: 76%;
      padding: 5px;
    }
    ul {
      list-style: none;
      li {
        box-sizing: border-box;
        margin: 5px 0;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        border-bottom: 1px dashed #ccc;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
        -webkit-line-clamp: 1; /* 控制最多显示几行 */
        -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
        padding-left: 5px;
      }
    }
  }
}
.title {
  color: #000;
}
</style>
